import React from "react";
import { Section } from "../../../../components";
import { Link as RouterLink } from "react-router-dom";
import { useRequestContext } from "../../../../context";
import { Button, Link, Typography, Box, Grid } from "@material-ui/core";

export const SelectType: React.FC = () => {
  const [requestContextState, requestContextDispatch] = useRequestContext();
  const active = React.useMemo(() => {
    const { name, view } = requestContextState.step;

    return name === "type" && view === "select-type";
  }, [requestContextState.step]);

  return (
    <Section active={active}>
      <Grid container spacing={2} component={Box} flexGrow={1}>
        <Grid item xs={12}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            height="100%"
          >
            <Box
              height={256}
              pl={8}
              display="flex"
              flexDirection="column"
              borderLeft={1}
              borderColor="text.disabled"
            >
              <Typography component={Box}>
                <Link color="primary" component={RouterLink} to="/">
                  &larr; Go back
                </Link>
              </Typography>
              <Box display="flex" alignItems="center" flexGrow={1}>
                <Box ml={0}>
                  <Button
                    size="large"
                    onClick={React.useCallback(() => {
                      requestContextDispatch({
                        type: "set-type",
                        value: "new",
                      });
                      requestContextDispatch({
                        type: "set-step",
                        name: "user-information",
                        view: "select-target",
                      });
                    }, [requestContextDispatch])}
                  >
                    New Access
                  </Button>
                </Box>
                <Box ml={2}>
                  <Button
                    size="large"
                    onClick={React.useCallback(() => {
                      requestContextDispatch({
                        type: "set-type",
                        value: "modify",
                      });
                      requestContextDispatch({
                        type: "set-step",
                        name: "user-information",
                        view: "select-target",
                      });
                    }, [requestContextDispatch])}
                  >
                    Modify Access
                  </Button>
                </Box>
                <Box ml={2}>
                  <Button
                    size="large"
                    onClick={React.useCallback(() => {
                      requestContextDispatch({
                        type: "set-type",
                        value: "revoke",
                      });
                      requestContextDispatch({
                        type: "set-step",
                        name: "user-information",
                        view: "users-list",
                      });
                      requestContextDispatch({
                        type: "set-target",
                        value: "MULTIPLE",
                      });
                    }, [requestContextDispatch])}
                  >
                    Revoke Access
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Section>
  );
};
